import { render, staticRenderFns } from "./form24Qacknowledgement.vue?vue&type=template&id=84fad45e&scoped=true&lang=html"
import script from "./form24Qacknowledgement.vue?vue&type=script&lang=js"
export * from "./form24Qacknowledgement.vue?vue&type=script&lang=js"
import style0 from "./form24Qacknowledgement.vue?vue&type=style&index=0&id=84fad45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fad45e",
  null
  
)

export default component.exports